import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import currencies from './data/currencies-fi';
import FiatCurrencySelectorValue from '../FiatCurrencySelectorValue';
import FiatCurrencySelectorOption from '../FiatCurrencySelectorOption';
import PropTypes from 'prop-types';
import './styles/select-styles.css';

const mappedCurrencies = [];

for (let key in currencies) {
  if (currencies.hasOwnProperty(key)) {
    mappedCurrencies.push({
      value: currencies[key].code,
      label: currencies[key].name,
    });
  }
}

export default class FiatCurrencySelector extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Select
        className={'fiat-currency-list'}
        name="form-field-name"
        onChange={this.props.onFiatCurrencyChange}
        options={mappedCurrencies}
        value={this.props.defaultCurrency.value}
        placeholder={<span>Select</span>}
        valueComponent={FiatCurrencySelectorValue}
        optionComponent={FiatCurrencySelectorOption}
        clearable={false}
        wrapperStyle={{ width: '220px' }}
      />
    );
  }
}

FiatCurrencySelector.propTypes = {
  defaultCurrency: PropTypes.object,
  onFiatCurrencyChange: PropTypes.func,
};
